import type {ExtractPropsWithoutRef} from '@/types';
import type {StyledComponent} from '@emotion/styled';

import styled from '@emotion/styled';

/**
 * @example const LinkButton = asComponent(Button, 'a');
 * @param Component a styled component you want to render differntly with `as` prop
 * @param As either `keyof JSX.IntrinsicElements`, a function component or a styled component
 * @returns React.FunctionComponent
 */
export const asComponent = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TS will infer this correctly so we do not need to care
  K extends StyledComponent<any>,
  T extends React.ElementType,
>(
  Component: K,
  As: T
) =>
  styled(
    (
      props: JSX.LibraryManagedAttributes<K, ExtractPropsWithoutRef<K>> &
        ExtractPropsWithoutRef<T> & {as?: never} // somehow we can not Omit the as prop so we change it to never
    ) => <Component {...props} as={As} />
  )``;
